import React, { useEffect, useState } from "react";
import "./CountCard.css";
import Popup from "reactjs-popup";
import { functionCalSeverity } from "../../../utils/functions";
import { LocalStorageConstant } from "../../../utils/constants";
import DraftsIcon from "@mui/icons-material/Drafts";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";

const iconImages = {
  icon1: (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3733 13.7729C12.0422 13.6209 11.7472 13.4003 11.5081 13.1255C11.2689 12.8506 11.0914 12.5276 10.9866 12.1787H7.05299C6.94624 12.527 6.76534 12.8492 6.52564 13.1235C6.28594 13.3979 5.99125 13.6185 5.66041 13.771C5.33177 13.9211 4.97483 13.9985 4.61353 13.9985C4.25224 13.9985 3.89529 13.9211 3.56666 13.771C3.23717 13.6181 2.94335 13.3969 2.70533 13.1226C2.46731 12.8482 2.29063 12.5265 2.1858 12.1787H0.785407C0.681216 12.1785 0.578661 12.1577 0.482673 12.1172C0.386685 12.0767 0.299601 12.0174 0.226813 11.9429C0.0784803 11.7895 -0.00452342 11.5845 -0.00365537 11.3711L0.0979071 2.8291C0.0992789 2.61502 0.182295 2.4096 0.332282 2.25684C0.405339 2.18209 0.493753 2.12256 0.590095 2.08203C0.686437 2.0415 0.790262 2.02095 0.894782 2.021H9.09986L9.36158 0.648926C9.39815 0.467617 9.49548 0.304187 9.63697 0.185059C9.77884 0.066293 9.95781 0.00108314 10.1428 0.000976562H11.637C11.8093 0.00118914 11.9763 0.0578606 12.1135 0.162109C12.2504 0.267779 12.3503 0.4141 12.3987 0.580078L12.8245 2.021H13.9827C14.1086 2.0211 14.2317 2.05074 14.344 2.10791C14.4563 2.16508 14.553 2.24827 14.6272 2.3501L17.1213 5.8501L18.7385 7.32373C18.8211 7.40151 18.8872 7.49584 18.9319 7.6001C18.9766 7.70435 18.9988 7.81625 18.9983 7.92969V11.3721C18.9986 11.5861 18.9161 11.7914 18.7659 11.9438C18.6929 12.0181 18.606 12.0772 18.51 12.1177C18.4141 12.1582 18.3095 12.1791 18.2053 12.1797H15.8499C15.7455 12.5285 15.5672 12.8511 15.3284 13.126C15.0896 13.4008 14.794 13.6219 14.4631 13.7739C14.1341 13.925 13.7764 14.0028 13.4143 14.002C13.0545 14.0019 12.7 13.9238 12.3733 13.7729ZM12.7405 10.73C12.5628 10.9149 12.4632 11.1615 12.4631 11.418C12.4639 11.6743 12.5634 11.9206 12.7405 12.106C12.9204 12.2873 13.1647 12.39 13.4202 12.3911C13.5463 12.3914 13.6712 12.366 13.7874 12.3169C13.9035 12.2677 14.0084 12.1957 14.096 12.105C14.2766 11.9219 14.3784 11.6752 14.3792 11.418C14.3799 11.2903 14.3555 11.1635 14.3069 11.0454C14.2583 10.9273 14.1863 10.8202 14.096 10.73C14.0085 10.639 13.9036 10.5667 13.7874 10.5176C13.6712 10.4684 13.5463 10.4433 13.4202 10.4438C13.2936 10.4444 13.1677 10.47 13.051 10.519C12.9343 10.5681 12.8294 10.6399 12.7405 10.73ZM3.9397 10.73C3.76186 10.915 3.66168 11.1613 3.66041 11.418C3.66168 11.6746 3.76186 11.9209 3.9397 12.106C4.1199 12.2869 4.364 12.3895 4.61939 12.3911C4.74568 12.3905 4.87217 12.365 4.98853 12.3159C5.1049 12.2668 5.20858 12.195 5.29713 12.105C5.47546 11.9205 5.57631 11.6745 5.57838 11.418C5.57878 11.1606 5.47758 10.9135 5.29713 10.73C5.20871 10.6398 5.10493 10.5681 4.98853 10.519C4.87214 10.4699 4.74572 10.4442 4.61939 10.4438C4.36377 10.4453 4.11949 10.5483 3.9397 10.73ZM14.4397 9.04688C14.7631 9.19259 15.0527 9.4035 15.2913 9.66602C15.5299 9.92853 15.7122 10.2369 15.8264 10.5728H17.4124L17.4182 8.28809L16.2268 7.19873H10.9338C10.8288 7.19865 10.724 7.1779 10.6272 7.13721C10.5304 7.09652 10.443 7.03689 10.3694 6.96191C10.2211 6.80891 10.1381 6.60417 10.1389 6.39111V3.63672H1.6858L1.60377 10.5718H2.21705C2.32937 10.2349 2.50988 9.92532 2.7483 9.66211C2.98672 9.3989 3.27762 9.18797 3.60181 9.04297C3.92342 8.89882 4.27281 8.82422 4.62525 8.82422C4.97769 8.82422 5.32513 8.89882 5.64674 9.04297C5.97046 9.18834 6.26025 9.39942 6.4983 9.6626C6.73634 9.92577 6.91728 10.2351 7.02955 10.5718H11.012C11.1258 10.236 11.3069 9.92756 11.5452 9.66504C11.7834 9.40252 12.0736 9.19169 12.3967 9.0459C12.7188 8.90271 13.0677 8.82899 13.4202 8.8291C13.7709 8.83001 14.1172 8.90371 14.4378 9.0459L14.4397 9.04688ZM11.7229 5.58496H14.9729L13.5823 3.6377H11.7229V5.58496ZM10.717 2.02197H11.1682L11.0491 1.62207H10.7952L10.717 2.02197ZM5.52564 8.52197V7.2749H4.29908V5.65967H5.52564V4.41309H7.11549V5.65967H8.34595V7.2749H7.11549V8.52197H5.52564Z"
        fill="#B2292E"
      />
    </svg>
  ),
  icon2: (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.87188 0.483018L0.825873 11.373C0.325873 12.29 0.53688 13.167 1.89588 13.167H13.4069C14.7699 13.167 14.9799 12.29 14.4769 11.373L8.30588 0.512017C8.25542 0.367055 8.16236 0.240709 8.03889 0.149529C7.91541 0.0583496 7.76727 0.00658506 7.61388 0.0010156C7.4565 -0.00053885 7.30216 0.0443616 7.17017 0.130097C7.03819 0.215833 6.93443 0.338597 6.87188 0.483018ZM6.85587 3.96902H8.27088V8.92101H6.85587V3.96902ZM6.85587 9.98201H8.27088V11.397H6.85587V9.98201Z"
        fill="#D86018"
      />
    </svg>
  ),
  icon3: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.055"
      height="15.639"
      viewBox="0 0 13.055 15.639"
    >
      <path
        id="Path_106101"
        data-name="Path 106101"
        d="M165.6,28a.4.4,0,0,0-.4.4V43.244a.4.4,0,0,0,.791,0V28.4A.4.4,0,0,0,165.6,28Zm11.114,1.582a8.784,8.784,0,0,0-3.4.822,7.5,7.5,0,0,1-6.923-.55V37a7.372,7.372,0,0,0,6.923.55c3.365-1.409,4.945-.544,4.945-.544V29.861A3.337,3.337,0,0,0,176.711,29.582Z"
        transform="translate(-165.201 -28)"
        fill="#f1c400"
      />
    </svg>
  ),
  icon4: (
    <svg
      id="noun-warning-18974"
      xmlns="http://www.w3.org/2000/svg"
      width="14.149"
      height="13.166"
      viewBox="0 0 14.149 13.166"
    >
      <path
        id="Path_106100"
        data-name="Path 106100"
        d="M132.289,73.619l-6.046,10.89c-.5.917-.289,1.794,1.07,1.794h11.511c1.363,0,1.573-.877,1.07-1.794l-6.171-10.861a.762.762,0,0,0-.692-.511.8.8,0,0,0-.742.482Zm-.016,3.486h1.415v4.952h-1.415Zm0,6.013h1.415v1.415h-1.415Z"
        transform="translate(-125.995 -73.136)"
        fill="#3D19A5"
      />
    </svg>
  ),
  icon5: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      fill="none"
      stroke-width="1.5"
      viewBox="0 0 24 24"
      color="#6082B6"
    >
      <path
        stroke="#6082B6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="1.5"
        d="M8 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      ></path>
      <path
        stroke="#6082B6"
        stroke-width="1.5"
        stroke-linecap="round"
        d="M10.05 17H15V6.6a.6.6 0 0 0-.6-.6H1M5.65 17H3.6a.6.6 0 0 1-.6-.6v-4.9"
      ></path>
      <path
        stroke="#6082B6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M2 9h4"
      ></path>
      <path
        stroke="#6082B6"
        stroke-width="1.5"
        stroke-linecap="round"
        d="M15 9h5.61a.6.6 0 0 1 .548.356l1.79 4.028a.6.6 0 0 1 .052.243V16.4a.6.6 0 0 1-.6.6h-1.9M15 17h1"
      ></path>
    </svg>
  ),
};

const CountCard = ({ handleSeverityChange, data }) => {
  const [activeStatus, setActiveStatus] = useState({
    notMeasured: true,
    healthy: true,
    Minor: false,
    Major: false,
    Critical: false,
  });
  const [workOrderCount, setWorkOrderCount] = useState({
    closed: 0,
    in_progress: 0,
    teco: 0,
  });
  const workOrders = useSelector((state) => state.dashboardReducer.work_orders);
  useEffect(() => {
    let workCount = {
      closed: 0,
      in_progress: 0,
      teco: 0,
    };
    workOrders.forEach((workOrder) => {
      if (workOrder.Status == "Planned") {
        workCount["in_progress"]++;
      } else if (workOrder.Status == "Closed") {
        workCount["closed"]++;
      } else {
        workCount["teco"]++;
      }
    });

    setWorkOrderCount(workCount);
  }, [workOrders]);

  useEffect(() => {
    const getSeverityFilter = JSON.parse(
      localStorage.getItem(LocalStorageConstant.DASHBOARD_SEVERITY_FILTER)
    );
    if (getSeverityFilter) {
      setActiveStatus(getSeverityFilter);
    }
  }, []);
  const severityChange = (e) => {
    let key = e.target.closest("div.switch-box").dataset.severity;
    let value = {
      ...activeStatus,
      [key]: !activeStatus[key],
    };
    setActiveStatus(value);
    handleSeverityChange(activeStatus, key);
  };

  const severityCount = functionCalSeverity(data);
  return (
    <div className="v1-main-header">
      <div className="v1-main-sub-header">
        {/* Data Connectivity */}
        <div className="card cardsmall">
          <h5 style={{ color: "#333F48" }}>Data Connectivity</h5>
          <hr className="count-line"></hr>
          <div className="v1-subbody">
            <div className="v1-subbodyFont">
              <i className={`icon-network`} style={{ color: "#B2292E" }}></i>
              <p>&gt; 24 hrs</p>
              <b>75</b>
            </div>
            <div className="v1-subbodyFont">
              <i className={`icon-network`} style={{ color: "#F1C400" }}></i>
              <p>&gt; 12 hrs</p>
              <b>25</b>
            </div>
            <div className="v1-subbodyFont">
              <i className={`icon-network`} style={{ color: "#25BC2B" }}></i>
              <p>&gt; 8hrs</p>
              <b>55</b>
            </div>
          </div>
        </div>
        {/* Health Matrix */}
        <div className="card cardbig">
          <h5 style={{ color: "#333F48" }}>Health Matrix</h5>
          <hr className="count-line"></hr>
          <div
            className="mb-2"
            style={{ display: "flex", justifyContent: "space-around" }}
          >
            <Popup
              key={`switch-2`}
              contentStyle={{
                backgroundColor: "#B2292E",
                borderRadius: "5px",
                height: "auto",
                color: "#fff",
                borderBottom: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "16px",
                lineHeight: "1.5",
                padding: "8px",
              }}
              arrowStyle={{ color: "#B2292E" }}
              trigger={
                <div
                  className="switch-box danger"
                  onClick={severityChange}
                  data-severity="Critical"
                >
                  <div className="switch-icon switch-icon-critical">
                    {iconImages.icon1}
                  </div>
                  <div
                    className={`switch-value critical ${
                      activeStatus.Critical ? "active" : "inactive"
                    }`}
                  >
                    <span>
                      {severityCount[1] ? severityCount[1]["count"] : 0}
                    </span>
                  </div>
                </div>
              }
              position="top right"
              // closeOnDocumentClick
              on={["hover", "focus"]}
            >
              <span>Critical</span>
            </Popup>
            <Popup
              key={`switch-3`}
              contentStyle={{
                backgroundColor: "#D86018",
                borderRadius: "5px",
                height: "auto",
                color: "#fff",
                borderBottom: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "16px",
                lineHeight: "1.5",
                padding: "8px",
              }}
              arrowStyle={{ color: "#D86018" }}
              trigger={
                <div
                  className="switch-box pending"
                  onClick={severityChange}
                  data-severity="Major"
                >
                  <div className="switch-icon switch-icon-major">
                    {iconImages.icon2}
                  </div>
                  <div
                    className={`switch-value pending ${
                      activeStatus.Major ? "active" : "inactive"
                    }`}
                  >
                    <span>
                      {severityCount[0] ? severityCount[0]["count"] : 0}
                    </span>
                  </div>
                </div>
              }
              position="top right"
              // closeOnDocumentClick
              on={["hover", "focus"]}
            >
              <span>Major</span>
            </Popup>

            <Popup
              key={`switch-1`}
              contentStyle={{
                backgroundColor: "#F1C400",
                borderRadius: "5px",
                height: "auto",
                color: "#fff",
                borderBottom: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "16px",
                lineHeight: "1.5",
                padding: "8px",
              }}
              arrowStyle={{ color: "#F1C400" }}
              trigger={
                <div
                  className="switch-box warning"
                  onClick={severityChange}
                  data-severity="Minor"
                >
                  <div className="switch-icon switch-icon-minor">
                    {iconImages.icon3}
                  </div>
                  <div
                    className={`switch-value warning ${
                      activeStatus.Minor ? "active" : "inactive"
                    }`}
                  >
                    <span>
                      {severityCount[2] ? severityCount[2]["count"] : 0}
                    </span>
                  </div>
                </div>
              }
              position="top right"
              // closeOnDocumentClick
              on={["hover", "focus"]}
            >
              <span>Minor</span>
            </Popup>
          </div>
          <div className="v1-subbody">
            <div className="v1-subbodyFont">
              <p>Events</p>
              <b>40</b>
            </div>
            <div className="v1-subbodyFont">
              <p>Analytics</p>
              <b>11</b>
            </div>
            <div className="v1-subbodyFont">
              <p>SOS</p>
              <b>25</b>
            </div>
            <div className="v1-subbodyFont">
              <p>MCM</p>
              <b>10</b>
            </div>
          </div>
        </div>
        {/* Recommendation */}
        <div className="card cardbig">
          <h5 style={{ color: "#333F48" }}>Recommendation</h5>
          <hr className="count-line"></hr>
          <div className="v1-subbody">
            <div className="v1-subbodyFont">
              <div>
                <DraftsIcon color="primary" fontSize="inherit" />
              </div>

              <p>Draft</p>
              <b>{Math.round(workOrderCount?.teco / 2)}</b>
            </div>
            <div className="v1-subbodyFont">
              <div>
                <RefreshIcon color="primary" fontSize="inherit" />
              </div>

              <p>In Progress</p>
              <b>{Math.round(workOrderCount?.in_progress / 2)}</b>
            </div>
            <div className="v1-subbodyFont">
              <div>
                <CloseIcon color="primary" fontSize="inherit" />
              </div>
              <p>Closed</p>
              <b>{Math.round(workOrderCount?.closed / 2)}</b>
            </div>
          </div>
        </div>
        {/* Work Order */}
        <div className="card cardsmall">
          <h5 style={{ color: "#333F48" }}>Work Order</h5>
          <hr className="count-line"></hr>
          <div className="v1-subbody">
            <div className="v1-subbodyFont">
              <RefreshIcon color="primary" fontSize="inherit" />

              <p>In Progress</p>
              <b>{workOrderCount?.in_progress}</b>
            </div>
            <div className="v1-subbodyFont">
              <CloseIcon color="primary" fontSize="inherit" />
              <p>Closed</p>
              <b>{workOrderCount?.closed}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountCard;
